import React from 'react';

const GetStarted = React.lazy(() => import('./pages/GetStarted'));
const StarterKit = React.lazy(() => import('./pages/StarterKit'));
const Products = React.lazy(() => import('./pages/Products'));
const SetupEmail = React.lazy(() => import('./pages/SetupEmail'));
// const EmailConfirmation = React.lazy(() => import('./pages/EmailVerification'));
const BillingAddress = React.lazy(() => import('./pages/BillingAddress'));
const ShippingAddress = React.lazy(() => import('./pages/ShippingAddress'));

interface IRoute {
  path: string;
  name: string;
  element: JSX.Element;
}

const routes: IRoute[] = [
  {
    path: 'home',
    name: 'Home',
    element: <GetStarted />,
  },
  {
    path: 'starter-kit',
    name: 'Starter Kit',
    element: <StarterKit />,
  },
  {
    path: 'products',
    name: 'Products',
    element: <Products />,
  },
  {
    path: 'setup-email',
    name: 'Setup Email',
    element: <SetupEmail />,
  },
  // {
  //   path: 'confirm-email',
  //   name: 'Confirm Email',
  //   element: <EmailConfirmation />,
  // },
  {
    path: 'billing-setup',
    name: 'Billing Address',
    element: <BillingAddress />,
  },
  {
    path: 'shipping-setup',
    name: 'Shipping Address',
    element: <ShippingAddress />,
  },
];

export default routes;
